

angular
.module('inkfinder')
.factory('Schedule', function Schedule(
  $q,
  $http,
  $rootScope,
  $interval,
  ENDPOINT,
  Shop,
  ScheduleUtilFactory,
  Session,
  moment,
  _
) {
  // Public methods
  Schedule.fetchSchedules = fetchSchedules;
  Schedule.editRule = editRule;
  Schedule.removeRule = removeRule;
  Schedule.getArtistSchedule = getArtistSchedule;
  Schedule.parseSchedules = parseSchedules;
  Schedule.refreshSchedules = refreshSchedules;
  Schedule.generate_selected_days_object = generate_selected_days_object;

  // Private variables
  let qwe;

  // Called to Reset Data on Logout
  let deregister = $rootScope.$on('clear-data', function() {
    $interval.cancel(qwe.schedules.timer);
    resetVariables();
  });
  $rootScope.$on('$destroy', deregister);

  resetVariables();

  /**
   * @name resetVariables
   */
  function resetVariables() {
    qwe = {
      schedules: {}
    };
    Schedule.rules = [];
  }

  /**
   * @name createScheduleTimer
   */
  function createScheduleTimer() {
    if (!qwe.schedules.timer) {
      qwe.schedules.timer = $interval(makeNewSchedulePromise, 1000);
    }
  }

  /**
   * @name makeNewSchedulePromise
   */
  function makeNewSchedulePromise() {
    if (!shouldRefresh()) {
      return;
    }

    qwe.schedules.promise = $q(function(resolve, reject) {
      let id = Session.activeState.association.id;
      if (id) {
        qwe.schedules.refreshing = true;

        // Check if artist is logged in
        if (Session.activeState.role === 'artist') {
          // call for single artist hours
          let shopId = Session.activeState.association.shop.id;
          $http.get(ENDPOINT.server +
          'schedules/api/v1.1/artist-hours/?artist_id=' +
          Session.collector.id + '&shop_id=' + shopId)
          .then(function(response) {
            if (qwe.schedules.timer) {
              parseSchedules(response.data);
              Schedule.rules = response.data;
              qwe.schedules.updated = moment();
              resolve(Schedule.rules);
            }
            qwe.schedules.refreshing = false;
            resolve(Schedule.rules);
          }, function(error) {
            reject(error);
          });
        } else {
          // For all other user types, like operator
          $http.get(ENDPOINT.server +
          'schedules/api/v1.1/artist-hours/all/?association_id=' + id)
          .then(function(response) {
            if (qwe.schedules.timer) {
              parseSchedules(response.data);
              Schedule.rules = response.data;
              qwe.schedules.updated = moment();
              resolve(Schedule.rules);
            }
            qwe.schedules.refreshing = false;
            resolve(Schedule.rules);
          }, function(error) {
            reject(error);
          });
        }
      } else {
        reject('Association not Set');
      }
    });
  }

  /**
   * @name shouldRefresh
   * @return {unknown} Unknown
   */
  function shouldRefresh() {
    return !qwe.schedules.refreshing && (!qwe.schedules.updated ||
    moment().diff(qwe.schedules.updated, 'seconds') >= 61);
  }

  /**
   * @name fetchSchedules
   * @return {unknown} Unknown
   */
  function fetchSchedules() {
    createScheduleTimer();
    makeNewSchedulePromise();
    return qwe.schedules.promise;
  }

  /**
   * @name refreshSchedules
   * @return {unknown} Unknown
   */
  function refreshSchedules() {
    qwe.schedules.updated = null;
    return fetchSchedules();
  }

  /**
   * @name parseSchedules
   * @param {unknown} data Unknown
   */
  function parseSchedules(data) {
    for (let i = 0; i < data.length; i++) {
      let rule = data[i];
      rule.start = moment(rule.start_date + 'T' + rule.start_time);
      rule.first_sunday = moment(rule.start).startOf('week');
      ScheduleUtilFactory.booleansToDays(rule);
      ScheduleUtilFactory.daysToText(rule);
      if (rule.end_date) {
        rule.end = moment(rule.end_date + 'T' + rule.end_time);
      }
    }
  }

  /**
   * @name getArtistSchedule
   * @description Unknown
   * @param {Unknown} id Unknown
   * @return {unknown} Unknown
   */
  function getArtistSchedule(id) {
    let returnVal = [];
    for (let i = 0; i < Schedule.rules.length; i++) {
      if (Schedule.rules[i].artist === id) {
        returnVal.push(Schedule.rules[i]);
      }
    }
    return returnVal;
  }

  Schedule.check_dates = function(form, override, today) {
    let errors = [];
    if (form.temp.raw_end_date) {
      if (moment(form.temp.raw_end_date).startOf('day').unix() <
      moment(form.temp.raw_start_date).startOf('day').unix()) {
        errors.push('End date cannot be before start date.');
      }
      if (moment(form.temp.raw_end_date).startOf('day').unix() <
      moment().startOf('day').unix()) {
        errors.push('End date cannot be before today.');
      }
    }
    if (moment(form.temp.raw_start_date).startOf('day').unix() <
    moment().startOf('day').unix() && override) {
      errors.push('You can’t add a schedule to the past.');
    }
    return errors;
  };

  // Submit the Exception to the API
  Schedule.submitNewRule = function(rule) {
    rule.role = Session.activeState.role;
    rule.association_id = Session.activeState.association.id;

    return $http.post(ENDPOINT.server +
    'schedules/api/v1.1/artist-hours/create/', rule)
      .then(function(response) {
        return response.data;
      }, function(error) {
        throw error;
      });
  };

  /**
   * @name editRule
   * @description description
   * @param {type} rule Description
   * @return {type} Description
   */
  function editRule(rule) {
    rule.association_id = Session.activeState.association.id;
    return $http.post(ENDPOINT.server +
    'schedules/api/v1.1/artist-hours/' + rule.artist_hour_id + '/', rule)
      .then(function(response) {
        return response.data;
      }, function(error) {
        throw error;
      });
  }

  /**
   * @name removeRule
   * @description description
   * @param {type} rule Description
   * @param {type} day Description
   * @return {type} Description
   */
  function removeRule(rule, day) {
    // Becuase we want to preserve the rules, we expire the rule by setting it before the currently selected day.
    let processed = _.cloneDeep(rule);

    if (moment(rule.start_date).startOf('day') >= moment().startOf('day')) {
      processed.deleted = true;
    } else if (rule.is_off) {
      processed.end_date = moment().startOf('day').format('YYYY-MM-DD');
    } else if (moment(rule.start_time, 'HH:mm:ss').unix() > moment(rule.end_time, 'HH:mm:ss').unix()) {
      processed.end_date = moment().startOf('day').format('YYYY-MM-DD');
    } else {
      processed.end_date = moment().startOf('day').subtract(1, 'day').format('YYYY-MM-DD');
    }

    processed.association_id = Session.activeState.association.id;

    let url = ENDPOINT.server + 'schedules/api/v1.1/artist-hours/' + processed.artist_hour_id + '/';

    return $http.post(url, processed)
      .then(function(response) {
        return response.data;
      }, function(error) {
        throw error;
      });
  }

  Schedule.sort_hour_types = function(hours, date) {
    let hours_by_rules = [];
    let hours_by_exceptions = [];
    let hours_by_off = [];
    // let off_count = 0;

    _.each(hours, function(hour_data) {
      // If no end_date is set the schedule hasn't expired. If the end date is specified make sure it's still valid.
      if (moment(hour_data.end_date, 'YYYY-MM-DD').endOf('day').unix() >= date.unix() || !hour_data.end_date) {
        if (hour_data.is_exception === true) {
          hours_by_exceptions.push(hour_data);
        } else {
          hours_by_rules.push(hour_data);
        }
        if (hour_data.is_off === true) {
          hours_by_off.push(hour_data);
        }
      }
    });
    return {
      by_rules: hours_by_rules,
      by_exceptions: hours_by_exceptions
    };
  };

  /**
   * @name generate_selected_days_object
   * @description description
   * @param {type} day Description
   * @param {type} all Description
   * @return {type} Description
   */
  function generate_selected_days_object(day, all) {
    let processed = [];
    if (all) {
      return processed.concat(ScheduleUtilFactory.daysArray);
    }
    return processed.concat(ScheduleUtilFactory.days[day.format('dddd')
    .toLowerCase()]);
  }
  return Schedule;
});



// WEBPACK FOOTER //
// ./components/schedule/schedules.service.js